import React, { useState, useEffect } from 'react';
import { useMemo } from 'react';
import _ from 'lodash';

import CallCostsComponent from './CallCostsComponent';
import TelecomServicesSection from './TelecomServiceSection'; 
//import { useToast } from '../hooks/use-toast';
import {  Phone, Mail, User, Building2, CheckCircle, AlertCircle, Search,  ChevronDown, ChevronUp, Settings, Wifi, Globe, Monitor, Smartphone, Headphones, Tablet, Plus, X, Edit2, CalculatorIcon  } from 'lucide-react';
import connectionService from '../services/connectionService';
import { fetchMechanicsData } from '../services/mechanicsService'; 

//import { useToast } from '../hooks/use-toast';
import { 
  saveSystemConfig, 
  updateSystemConfig ,
  getAdminSystemConfig
} from '../services/systemConfigService';

import QuoteProgressService from '../services/quoteProgressService';


 const getDefaultHardwareItems = () => [
    { id: 1, name: 'Bell / Tannoy', quantity: 0, category: 'Audio', icon: '/images/bell.jpg' },
    { id: 2, name: 'Mobile App', quantity: 0, category: 'Software', icon: '/images/mobileapp.jpg' },
    { id: 3, name: 'Mobile App Addon', quantity: 0, category: 'Software', icon: '📱' },
    { id: 4, name: 'T54W', quantity: 0, category: 'Phone', icon: '/images/t54w.png' },
    { id: 5, name: 'T57W', quantity: 0, category: 'Phone', icon: '/images/t57w.jpg' },
    { id: 6, name: 'T58W', quantity: 0, category: 'Phone', icon: '/images/t58w.jpg' },
    { id: 7, name: 'Yealink W73H DECT', quantity: 0, category: 'Phone', icon: '/images/ipdect.jpg' },
    { id: 8, name: 'IP DECT Base', quantity: 0, category: 'Phone', icon: '/images/ipdect.jpg' },
    { id: 9, name: 'Wi-Fi Booster', quantity: 0, category: 'Network', icon: '/images/wifibooster.jpg' },
    { id: 10, name: 'Headsets', quantity: 0, category: 'Audio', icon: '/images/headset.jpg' },
    { id: 11, name: 'Fibre TV/Wallboard', quantity: 0, category: 'Display', icon: '/images/fibretv.jpg' },
    { id: 12, name: 'iPad', quantity: 0, category: 'Tablet', icon: '/images/ipad.png' },
    { id: 13, name: 'Fibre Audio', quantity: 0, category: 'Audio', icon: '🎧' },
    { id: 14, name: 'Add On', quantity: 0, category: 'Display', icon: '/images/fibretv.jpg' },
  ];

  const getDefaultAdditionalHardware = () => [
    { id: 'fibre', name: 'Fibre', quantity: 1, category: 'Music Module', icon: '/images/music.svg' },
    { id: 'media-player', name: 'Media Player', quantity: 1, category: 'Music Module', icon: '/images/module.svg' },
    { id: 'aa-voice-over', name: 'AA Voice Over', quantity: 1, category: 'Music Module', icon: '/images/music.svg' },
    { id: 'site-link-licence', name: 'Site Link Licence', quantity: 0, category: 'Site Link Licence', icon: '/images/sitelink.png' },
    { id: 'analogue-devices', name: 'Analogue Devices', quantity: 0, category: 'Site Link Licence', icon: '/images/sitelink.png' },
    { id: 'ups', name: 'UPS', quantity: 1, category: 'Protection', icon: '/images/protection.svg' },
    { id: 'surge-protection', name: 'Surge protection', quantity: 1, category: 'Protection', icon: '/images/protection.svg' },
    { id: 'pancode', name: 'Pancode', quantity: 0, category: 'Door entry', icon: '/images/doorentry.png' },
    { id: '1-button-entry', name: '1 Button Entry', quantity: 0, category: 'Door entry', icon: '/images/doorentry.png' },
    { id: 'ucm-ip-pbx', name: 'UCM IP PBX', quantity: 1, category: 'UCM IP PBX', icon: '/images/ucmippbx.jpg' },
    { id: 'voicemail-ports', name: 'Voicemail ports', quantity: 0, category: 'UCM IP PBX', icon: '/images/ucmippbx.jpg' },
    { id: 'wifi-enabled', name: 'Draytek 2865LAC', quantity: 0, category: 'Router', icon: '/images/router.png' },
    { id: '8-port-poe', name: 'Netgear GS108LP', quantity: 0, category: 'POE', icon: '/images/poe.png' },
    { id: '24-port-poe', name: '24 port POE', quantity: 0, category: 'POE', icon: '/images/poe.png' },
    { id: 'cat5e-cable-5m', name: 'Cat 5E Cable (5m)', quantity: 0, category: 'Cabling', icon: '/images/cat5e.jpg' },
    { id: 'system-moves', name: 'System Moves', quantity: 0, category: 'System Moves', icon: '/images/systemmoves.png' },
    { id: 'cat5', name: 'Cat 5', quantity: 0, category: 'System Moves', icon: '/images/systemmoves.png' },
  ];

  const getDefaultLineRequirements = () => ({
    existingIsdn2Channels: 0,
    newConversionIsdn2Channel: 0,
    existingIsdn30Channels: 0,
    newIsdn30Channel: 0
  });

  const getDefaultCurrentLines = () => ({
    hostedLifetimeLicenses: 0,
    analoguePstnLines: 0,
    adslFttcBroadband: 0,
    new4g5gBroadband: 0,
    fttpSogeaBroadband: 0
  });

  const getDefaultDataBroadband = () => ({
    starlinkBroadband: 0,
    leasedLines: 0
  });

  const getDefaultServiceCharges = () => ({
    service_charge: 0,
    equipment_rentals: 0,
    broadband: 0,
    media: 0,
    maintenance: 0,
    utilities: 0
  });
   const getDefaultDigitalServices = () => ({
    webHostingCost: 0,
    licenceServices: {},
    axoSignalPackage: null,
    totalNewDigitalCost: 0,
    totalFibreDigitalRevenue: 0,
  });

const AdminSystemConfig = ({selectedConnectionId}) => {
    // console.log("admin system id",selectedConnectionId);
    
  const [isOpen, setIsOpen] = useState(false);
  const [isLineServicesOpen, setIsLineServicesOpen] = useState(false);
  const [isHardwareOpen, setIsHardwareOpen] = useState(false);
  const [connections, setConnections] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [isLoadingConfig, setIsLoadingConfig] = useState(false);
  const [configError, setConfigError] = useState(null);
  
  // Initialize state to show form if connectionId is in URL
  const [showForm, setShowForm] = useState();

  const [selectedDate, setSelectedDate] = useState(null);
  const [emailExtraInput, setEmailExtraInput] = useState(0);

  const [editingId, setEditingId] = useState(null);
  const [showAddForm, setShowAddForm] = useState(false);
  const [autoCalculateMobileApp, setAutoCalculateMobileApp] = useState(true);
  const [error, setError] = useState(null);
  const [services, setServices] = useState([]);
  const [equipments, setEquipments] = useState([]);
  const [licenses, setLicenses] = useState([]);
  const [itSupportPricing, setItSupportPricing] = useState([]);
  const [isItServicesOpen, setIsItServicesOpen] = useState(false);

  // Add state to track if data has been loaded from existing config
  const [isExistingCustomer, setIsExistingCustomer] = useState(false);
  const [dataLoaded, setDataLoaded] = useState(false);


  // Initialize with default values
  const [hardwareItems, setHardwareItems] = useState(getDefaultHardwareItems());
  const [additionalHardware, setAdditionalHardware] = useState(getDefaultAdditionalHardware());
  const [lineRequirements, setLineRequirements] = useState(getDefaultLineRequirements());
  const [currentLines, setCurrentLines] = useState(getDefaultCurrentLines());
  const [dataBroadband, setDataBroadband] = useState(getDefaultDataBroadband());
  const [serviceChargesData, setServiceChargesData] = useState(getDefaultServiceCharges());
  const [existingConfigId, setExistingConfigId] = useState(null);
  const [progress, setProgress] = useState([]);
  const [adminUpdate, setUpdatedByAdmin] = useState(0);
  const [saveStatus, setSaveStatus] = useState('');

  const [newItem, setNewItem] = useState({
    name: '',
    quantity: 0,
    category: 'Phone',
    icon: '📞'
  });

  const categories = [
    { name: 'Phone', icon: '📞' },
    { name: 'Audio', icon: '🔔' },
    { name: 'Network', icon: '📶' },
    { name: 'Display', icon: '📺' },
    { name: 'Tablet', icon: '📱' },
    { name: 'Software', icon: '💻' },
    { name: 'Other', icon: '⚙️' }
  ];

  const getIconComponent = (category) => {
    switch (category) {
      case 'Phone': return <Phone className="w-5 h-5" />;
      case 'Audio': return <Headphones className="w-5 h-5" />;
      case 'Network': return <Wifi className="w-5 h-5" />;
      case 'Display': return <Monitor className="w-5 h-5" />;
      case 'Tablet': return <Tablet className="w-5 h-5" />;
      case 'Software': return <Smartphone className="w-5 h-5" />;
      default: return <Monitor className="w-5 h-5" />;
    }
  };

   const [leaseCalculatorData, setLeaseCalculatorData] = useState({
   paymentProfile:'84' , // Changed to string
   networkPayment: '0',
   discountLoad: 0,
   currentCallCharges: 0,
   estimatedCallCharges: 0,
   networkSettlementContribution: '0',
   adjustedRental: 0,
   actualLeasePayment: 0,
   actualProfit: 0,
   salesRepCommission: 0,
   current_lease_rental: 0,
   current_mobile_charges : 0,
   current_service_charges : 0,
   current_maintenance : 0,
   other_charges : 0,
   current_total_cost : 0,
   estimated_mobile_charges : 0,
   new_service_charges : 0,
   leased_line : 0,
   digital_services: null,
 });
  const [telecomServices, setTelecomServices] = useState([
   {
     id: Date.now(),
     description: '',
     service_type: '',
     existing_tel_no: '',
     existing_lines: '',  // This field
     postcode_of_homeworker: ''  // This field
   }
 ]);
 const [digitalServicesData, setDigitalServicesData] = useState(getDefaultDigitalServices());
 
 const getDefaultItServices = () => ({
   numberOfStations: 0,
   selectedPackages: ['it_support'],
   licenceQuantities: {},
 });
 const [itServicesData, setItServicesData] = useState(getDefaultItServices());

  // Effect to load existing configuration data
  useEffect(() => {
    const fetchConfigData = async () => {
      if (!selectedConnectionId) {
        // No connection ID, use defaults
        setDataLoaded(true);
        setIsExistingCustomer(false);
        return;
      }
      
      setIsLoadingConfig(true);
      setConfigError(null);
      
      try {
     
        const configData = await getAdminSystemConfig(selectedConnectionId);
        //console.log("id",selectedConnectionId);
        //console.log("getAdminData",configData)
        
        if (configData && Object.keys(configData).length > 0) {
          // Existing customer with saved config
        
          setIsExistingCustomer(true);
          
          // Merge existing data with defaults to ensure all fields are present
          setLineRequirements({
            ...getDefaultLineRequirements(),
            ...(configData.data.lineRequirements || {})
          });
          
          setCurrentLines({
            ...getDefaultCurrentLines(),
            ...(configData.data.currentLines || {})
          });
          
          setDataBroadband({
            ...getDefaultDataBroadband(),
            ...(configData.data.dataBroadband || {})
          });
          
          // For hardware items, use existing data or defaults
          if (configData.data.hardwareItems && Array.isArray(configData.data.hardwareItems)) {
            const defaultItems = getDefaultHardwareItems();
            
            const mergedItems = configData.data.hardwareItems.map(savedItem => {
              // Find matching default item by name
              const defaultItem = defaultItems.find(d => d.name === savedItem.name) || {
                // Fallback defaults if no match found
                id: savedItem.id || Date.now(),
                category: savedItem.category || 'Other',
                icon: '⚙️' // Default fallback icon
              };
              
              return {
                // Default properties first (including icon)
                ...defaultItem,
                // Then override with saved values
                ...savedItem,
                // Ensure we always have an icon (prioritize default icon over saved)
                icon: defaultItem.icon || savedItem.icon || '⚙️',
                // Ensure quantity is always a number
                quantity: typeof savedItem.quantity === 'number' ? savedItem.quantity : 0
              };
            });
            
            setHardwareItems(mergedItems);
          } else {
            setHardwareItems(getDefaultHardwareItems());
          }
          
          if (configData.data.additionalHardware && Array.isArray(configData.data.additionalHardware)) {
            // Get default additional hardware items
            const defaultAdditionalItems = getDefaultAdditionalHardware();
            
            // Merge saved items with defaults
            const mergedAdditionalItems = configData.data.additionalHardware.map(savedItem => {
              // Find matching default item by either id or name
              const defaultItem = defaultAdditionalItems.find(d => d.name === savedItem.name) || {
              // Fallback defaults if no match found
              id: savedItem.id || Date.now(),
              name: savedItem.name || savedItem.description || 'Unknown Item',
              category: savedItem.category || 'Other',
              icon: '⚙️' // Default fallback icon
            };
    
          return {
            ...defaultItem,
                // Then override with saved values
                ...savedItem,
                // Ensure we always have an icon (prioritize default icon over saved)
                icon: defaultItem.icon || savedItem.icon || '⚙️',
                // Ensure quantity is always a number
                quantity: typeof savedItem.quantity === 'number' ? savedItem.quantity : 0
          };
        });
        
            
            setAdditionalHardware(mergedAdditionalItems);
          } 
          else {
            setAdditionalHardware(getDefaultAdditionalHardware());
          }

          
            if (configData.data.charges) {
          setServiceChargesData({
            ...getDefaultServiceCharges(),
            ...configData.data.charges
          });
        } else {
          // Fallback to serviceCharges if charges doesn't exist
          setServiceChargesData({
            ...getDefaultServiceCharges(),
            ...(configData.data.serviceCharges || {})
          });
        }
          if (configData.data.leaseCalculations) {
            setLeaseCalculatorData({
              ...leaseCalculatorData, // keep defaults
              ...configData.data.leaseCalculations, // overwrite with saved values
               digital_services: configData.data.leaseCalculatorData.digital_services ?? null,
            });

            setItServicesData({
            ...getDefaultItServices(),
            ...(configData.data.itServices || {})
          });
            if (configData.data.leaseCalculations.digital_services) {
              setDigitalServicesData({
                ...getDefaultDigitalServices(),
                ...configData.data.leaseCalculations.digital_services,
              });
            }
            
          }
          setItServicesData({
            ...getDefaultItServices(),
            ...(configData.data.itServices || {})
          });
          
          setExistingConfigId(configData.data.id);
        } else {
          // Existing customer but no saved config - use defaults
          setIsExistingCustomer(false);
          // Keep the default values that were already set
        }
      } catch (error) {
        console.error('Failed to load config:', error);
        if (isExistingCustomer) {
          setConfigError('Failed to load configuration data');
      }
        // On error, keep defaults
        setIsExistingCustomer(false);
      } finally {
        setIsLoadingConfig(false);
        setDataLoaded(true);
      }
    };

    fetchConfigData();
  }, [selectedConnectionId]);

  const handleServiceChange = (index, field, value) => {
    const updatedServices = telecomServices.map((service, i) => 
      i === index ? { ...service, [field]: value } : service
    );
    setTelecomServices(updatedServices);
  };

  const handleAddService = () => {
    setTelecomServices([
      ...telecomServices,
      {
        id: Date.now(),
        description: '',
        service_type: '',
        existing_tel_no: '',
        existing_lines: '',
        postcode_of_homeworker: ''
      }
    ]);
  };

  const handleRemoveService = (index) => {
    if (telecomServices.length > 1) {
      setTelecomServices(telecomServices.filter((_, i) => i !== index));
    }
  };

  // Reset to defaults when connectionId changes (for new customers)
  useEffect(() => {
    if (!selectedConnectionId) {
   
      setHardwareItems(getDefaultHardwareItems());
      setAdditionalHardware(getDefaultAdditionalHardware());
      setLineRequirements(getDefaultLineRequirements());
      setCurrentLines(getDefaultCurrentLines());
      setDataBroadband(getDefaultDataBroadband());
      setServiceChargesData(getDefaultServiceCharges());
      setDigitalServicesData(getDefaultDigitalServices());
      setItServicesData(getDefaultItServices());
      setExistingConfigId(null);
      setIsExistingCustomer(false);
      setDataLoaded(true);
    }
  }, [selectedConnectionId]);

 

  const handleAddItem = () => {
    if (newItem.name.trim()) {
      const categoryData = categories.find(cat => cat.name === newItem.category);
      setHardwareItems([...hardwareItems, {
        id: Date.now(),
        ...newItem,
        icon: categoryData?.icon || '⚙️'
      }]);
      setNewItem({ name: '', quantity: 0, category: 'Phone', icon: '📞' });
      setShowAddForm(false);
    }
  };

  useEffect(() => {
    const getMechanicsUcmIp = async () => {
      try {
        const response = await fetchMechanicsData();
        setServices(response.data.services);
        setEquipments(response.data.equipment);
        setLicenses(response.data.licenses || []);
        setItSupportPricing(response.data.it_support || []);
      } catch (error) {
        console.error('Failed to fetch UCM IP PBX:', error);
      }
    };

    getMechanicsUcmIp();

    // Only run router calculations after data is loaded
    if (dataLoaded) {
      const routerTotal = currentLines.adslFttcBroadband +
        currentLines.new4g5gBroadband +
        currentLines.fttpSogeaBroadband +
        dataBroadband.starlinkBroadband +
        dataBroadband.leasedLines;

      setAdditionalHardware(prev =>
        prev.map(item => {
          if (
            item.name === 'Draytek 2865LAC' ||
            item.name === 'Netgear GS108LP'
          ) {
            return { ...item, quantity: routerTotal };
          }
          return item;
        })
      );
    }
  }, [currentLines, dataBroadband, dataLoaded]);

  const totalEmails = useMemo(() => {
    const t54w = hardwareItems.find(item => item.name === 'T54W')?.quantity || 0;
    const t57w = hardwareItems.find(item => item.name === 'T57W')?.quantity || 0;
    const ipDectHandset = hardwareItems.find(item => item.name === 'Yealink W73H DECT')?.quantity || 0;
    
    return (parseInt(emailExtraInput) || 0) + t54w + t57w + ipDectHandset;
  }, [hardwareItems, emailExtraInput]);

  const handleLineRequirementChange = (field, value) => {
    setLineRequirements(prev => ({
      ...prev,
      [field]: value === '' ? '' : parseInt(value) || 0
    }));
  };

  const handleCurrentLinesChange = (field, value) => {
    setCurrentLines(prev => ({
      ...prev,
      [field]: value === '' ? '' : parseInt(value) || 0
    }));
  };

  const handleDataBroadbandChange = (field, value) => {
    setDataBroadband(prev => ({
      ...prev,
      [field]: value === '' ? '' : parseInt(value) || 0
    }));
  };

  const handleStationsChange = (value) => {
    setItServicesData(prev => ({
      ...prev,
      numberOfStations: value === '' ? '' : parseInt(value) || 0
    }));
  };

  const handleTogglePackage = (key, checked) => {
    setItServicesData(prev => {
      const current = prev.selectedPackages || [];
      return {
        ...prev,
        selectedPackages: checked
          ? [...current, key]
          : current.filter(k => k !== key)
      };
    });
  };

  const handleLicenceQuantityChange = (licenseId, value) => {
    const qty = value === '' ? '' : parseInt(value) || 0;
    setItServicesData(prev => ({
      ...prev,
      licenceQuantities: { ...prev.licenceQuantities, [licenseId]: qty }
    }));
  };

  const handleEditItem = (id, field, value) => {
    const updatedItems = hardwareItems.map(item =>
      item.id === id
        ? { ...item, [field]: field === 'quantity' ? parseInt(value) || 0 : value }
        : item
    );

    // Step 1: Find Yealink W73H DECT quantity
    const ipDectHandset = updatedItems.find(item => item.name === 'Yealink W73H DECT');
    const ipDectHandsetQty = ipDectHandset?.quantity || 0;

    // Step 2: Set IP DECT Base quantity based on handset quantity
    const adjustedItems = updatedItems.map(item => {
      if (item.name === 'IP DECT Base') {
        return { ...item, quantity: ipDectHandsetQty > 0 ? 1 : 0 };
      }
      return item;
    });

    // Step 3: Calculate Mobile App total from relevant devices
    let mobileAppQty = adjustedItems.find(item => item.name === 'Mobile App')?.quantity || 0;

    if (autoCalculateMobileApp) {
      mobileAppQty = adjustedItems.reduce((sum, item) => {
        if (['T54W', 'T57W', 'T58W', 'Yealink W73H DECT','Mobile App Addon'].includes(item.name)) {
          return sum + item.quantity;
        }
        return sum;
      }, 0);

      // Update Mobile App automatically
      adjustedItems.forEach(item => {
        if (item.name === 'Mobile App') {
          item.quantity = mobileAppQty;
        }
      });
    }

    const finalItems = adjustedItems;
    
    const voiceMail = finalItems.reduce((sum, item) => {
      if (['T54W', 'T57W', 'T58W'].includes(item.name)) {
        return sum + item.quantity;
      }
      return sum;
    }, 0);

    const updatedAdditionalHardware = additionalHardware.map(item => {
      if (item.id === id) {
        return { ...item, [field]: field === 'quantity' ? parseInt(value) || 0 : value };
      }
      if (item.name === 'Voicemail ports') {
        return {
          ...item,
          quantity: voiceMail,
        };
      }
      if (item.name === 'Cat 5E Cable (5m)') {
        const handsetSum = finalItems.reduce((sum, handsetItem) => {
          if (['T54W', 'T57W', 'T58W', 'Yealink W73H DECT'].includes(handsetItem.name)) {
            return sum + (handsetItem.quantity || 0);
          }
          return sum;
        }, 0);
        return {
          ...item,
          quantity: handsetSum,
        };
      }
      return item;
    });

    setHardwareItems(finalItems);
    setAdditionalHardware(updatedAdditionalHardware);
    setCurrentLines(prev => ({
      ...prev,
      hostedLifetimeLicenses: mobileAppQty
    }));
  };

  // Add these helper functions at the top of your component
  const handleHardwareFocus = (id, field) => (e) => {
    const updatedItems = hardwareItems.map(item =>
      item.id === id ? { ...item, [field]: '' } : item
    );
    setHardwareItems(updatedItems);
  };

  const handleHardwareBlur = (id, field) => (e) => {
    const value = e.target.value === '' ? 0 : parseInt(e.target.value) || 0;
    handleEditItem(id, field, value);
  };

  const handleAdditionalHardwareFocus = (id, field) => (e) => {
    const updatedItems = additionalHardware.map(item =>
      item.id === id ? { ...item, [field]: '' } : item
    );
    setAdditionalHardware(updatedItems);
  };

  const handleAdditionalHardwareBlur = (id, field) => (e) => {
    const value = e.target.value === '' ? 0 : parseInt(e.target.value) || 0;
    
    // For additional hardware, we need to update the state directly
    const updatedItems = additionalHardware.map(item =>
      item.id === id ? { ...item, [field]: value } : item
    );
    setAdditionalHardware(updatedItems);
    
    // Also trigger any related calculations
    handleEditItem(id, field, value);
  };

  const handleDeleteItem = (id) => {
    setHardwareItems(hardwareItems.filter(item => item.id !== id));
  };

  const groupedItems = hardwareItems.reduce((acc, item) => {
    if (!acc[item.category]) {
      acc[item.category] = [];
    }
    acc[item.category].push(item);
    return acc;
  }, {});

  // Fetch services data
  const calculateAllCosts = useMemo(() => {
     
    if (!services || !currentLines || !dataBroadband || !lineRequirements || !hardwareItems) {
     return { totalMonthly: 0 }; // safe fallback
   }
 
     // Helper function to get price and format to 2 decimal places
     const getPrice = (serviceName) => {
       const service = services.find(s => s.name === serviceName);
       const price = service ? parseFloat(service.price) : 0;
       return parseFloat(price.toFixed(2));
     };
 
     // Helper function to round to 2 decimal places properly
     const roundToTwo = (num) => {
       return parseFloat((Math.round(num * 100) / 100).toFixed(2));
     };
 
     const fibre_fail_safe_sum = currentLines.adslFttcBroadband + currentLines.new4g5gBroadband +currentLines.fttpSogeaBroadband;
      
     // Calculate all costs with proper rounding
     const costs = {
       // Line services
       sogea: roundToTwo(currentLines.fttpSogeaBroadband * getPrice('SOGEA')),
       adsl: roundToTwo(currentLines.adslFttcBroadband * getPrice('FTTC BB')),
       fourG5g: roundToTwo(currentLines.new4g5gBroadband * getPrice('4G BB')),
       starlink: roundToTwo(dataBroadband.starlinkBroadband * getPrice('STARLINK')),
       analogue: roundToTwo(currentLines.analoguePstnLines * getPrice('ANALOGUE LINE')),
       isdn2: roundToTwo(lineRequirements.existingIsdn2Channels * getPrice('ISDN 2 CH')),
       
       // Hardware
       t58w: roundToTwo((hardwareItems.find(i => i.name === 'T58W')?.quantity || 0) * getPrice('T58W')),
       t57w: roundToTwo((hardwareItems.find(i => i.name === 'T57W')?.quantity || 0) * getPrice('T57W')),
       t54w: roundToTwo((hardwareItems.find(i => i.name === 'T54W')?.quantity || 0) * getPrice('T54W')),
       dect: roundToTwo((hardwareItems.find(i => i.name === 'Yealink W73H DECT')?.quantity || 0) * getPrice('DECT')),
       mobileApp: roundToTwo((hardwareItems.find(i => i.name === 'Mobile App')?.quantity || 0) * getPrice('LICENSE MAINT')),
       
       // Additional services
       fibre_safe: getPrice('FIBRE SAFE'),
       isdn_2_ch: getPrice('ISDN 2 CH'),
       fibre_web_listing: getPrice('FIBRE AI'),
       fibre_audio: (hardwareItems.find(i => i.name === 'Fibre Audio')?.quantity || 0) + getPrice('FIBRE AUDIO'),
       sip_trunck: roundToTwo((hardwareItems.find(i => i.name === 'Mobile App')?.quantity || 0) * getPrice('SIP TRUNK BUNDLE')),
       fibre_fail_safe: roundToTwo(fibre_fail_safe_sum * getPrice('FIBRE FAILSAFE')),
       leased_line: roundToTwo(dataBroadband.leasedLines * getPrice('LEASED LINE')),
 
     };
 
     // Calculate total with proper rounding
     if (!costs || typeof costs !== 'object') {
       costs = {};
     }
 
     costs.totalMonthly = roundToTwo(
       Object.values(costs).reduce((sum, value) => sum + parseFloat(value || 0), 0)
     );
 
     return costs;
   }, [services, currentLines, dataBroadband, lineRequirements, hardwareItems]);

   
 

  const calculateTotalHardwareCosts= useMemo(() => {
    if (!equipments || !currentLines || !dataBroadband || !lineRequirements || !hardwareItems) {
      return { totalMonthly: 0 }; // safe fallback
    }

    // Helper function to get price and format to 2 decimal places
    const getEquipmentPrice = (equipmentName) => {
      const equipment = equipments.find(s => s.name === equipmentName);
      const price = equipment ? parseFloat(equipment.price) : 0;
      return parseFloat(price.toFixed(2));
    };

    // Helper function to round to 2 decimal places properly
    const roundToTwo = (num) => {
      return parseFloat((Math.round(num * 100) / 100).toFixed(2));
    };
    
    const doorEntryQuantity = 
      (additionalHardware.find(i => i.name === 'Pancode')?.quantity || 0) +
      (additionalHardware.find(i => i.name === '1 Button Entry')?.quantity || 0);

    const cable5e = 
      (hardwareItems.find(i => i.name === 'T54W')?.quantity || 0) +
      (hardwareItems.find(i => i.name === 'T57W')?.quantity || 0)+
      (hardwareItems.find(i => i.name === 'T58W')?.quantity || 0);

    const lg_tv=  (hardwareItems.find(i => i.name === 'Fibre TV/Wallboard')?.quantity || 0) +
      (hardwareItems.find(i => i.name === 'Add On')?.quantity || 0);

    // Calculate all costs with proper rounding
    const equiment_costs = {
      hostedLifetimeLicenses: roundToTwo(currentLines.hostedLifetimeLicenses * getEquipmentPrice('SINGLE LIFETIME HOSTED LICENSE')),
      // Hardware
      t54w: roundToTwo((hardwareItems.find(i => i.name === 'T54W')?.quantity || 0) * getEquipmentPrice('T54W')),
      t57w: roundToTwo((hardwareItems.find(i => i.name === 'T57W')?.quantity || 0) * getEquipmentPrice('T57W')),
      t58w: roundToTwo((hardwareItems.find(i => i.name === 'T58W')?.quantity || 0) * getEquipmentPrice('T58W PRO')),
      
      number_port: getEquipmentPrice('NUMBER PORT'),
      new_number: getEquipmentPrice('NEW NUMBER PROVISION 2-9'),
      dect: roundToTwo((hardwareItems.find(i => i.name === 'Yealink W73H DECT')?.quantity || 0) * getEquipmentPrice('IP DECT')),
      bell: roundToTwo((hardwareItems.find(i => i.name === 'Bell / Tannoy')?.quantity || 0) * getEquipmentPrice('SIPP BELL')),
      headset: roundToTwo((hardwareItems.find(i => i.name === 'Headsets')?.quantity || 0) * getEquipmentPrice('WIRELESS HEADSET')),
      doorentry: roundToTwo(doorEntryQuantity * getEquipmentPrice('DOOR ENTRY SYSTEM (AVERAGE ONE)')),
      ipad: roundToTwo((hardwareItems.find(i => i.name === 'iPad')?.quantity || 0) * getEquipmentPrice('IPAD')),
      cat5e:roundToTwo((additionalHardware.find(i => i.name === 'Cat 5')?.quantity || 0) * getEquipmentPrice('CAT 5E CABLING')),
      sitemove:roundToTwo((additionalHardware.find(i => i.name === 'System Moves')?.quantity || 0) * getEquipmentPrice('SITE MOVE')),
      poe_switch: getEquipmentPrice('Netgear GS108LP SWITCH'),
      draytek_wifi: getEquipmentPrice('DRAYTEK WI-FI ROUTER'),
      robustel_4g_router: roundToTwo(currentLines.new4g5gBroadband * getEquipmentPrice('ROBUSTEL 4G ROUTER')),
      new_base_line: roundToTwo(currentLines.analoguePstnLines * getEquipmentPrice('NEW BASIC LINE')),
      override_comms: getEquipmentPrice('OVERRIDE COMMS'),
      tital_cat5cable: (cable5e * getEquipmentPrice('TITAL CAT 5 CABLE (2M)')),
      installation_charge: getEquipmentPrice('INSTALLATION CHARGE'),
      wifi: roundToTwo((hardwareItems.find(i => i.name === 'Wi-Fi Booster')?.quantity || 0) * getEquipmentPrice('WIFI BOOSTER')),
      lg_tv: roundToTwo(lg_tv * getEquipmentPrice('LG TV')),
      star_link:roundToTwo(dataBroadband.starlinkBroadband * getEquipmentPrice('STARLINK')),
      admin_fee:getEquipmentPrice('ADMIN FEE'),
    };

    // Calculate total with proper rounding
    if (!equiment_costs || typeof equiment_costs !== 'object') {
      equiment_costs = {};
    }

    equiment_costs.totalCost = roundToTwo(
      Object.values(equiment_costs).reduce((sum, value) => sum + parseFloat(value || 0), 0)
    );
    
    return equiment_costs;
  }, [services, currentLines, dataBroadband, lineRequirements, hardwareItems]);

  const calculateItServicesCost = useMemo(() => {
    const stations = parseInt(itServicesData.numberOfStations) || 0;

    const getItSupportPrice = (name) => {
      const item = itSupportPricing.find(i => i.name === name);
      return item ? parseFloat(item.price) || 0 : 0;
    };
    const getLicencePrice = (name) => {
      const item = licenses.find(l => l.name === name);
      return item ? parseFloat(item.price) || 0 : 0;
    };
    const roundToTwo = (num) => parseFloat((Math.round(num * 100) / 100).toFixed(2));

    const licenceBreakdown = licenses.map(license => {
      const qty = parseInt(itServicesData.licenceQuantities[license.id]) || 0;
      const price = parseFloat(license.price) || 0;
      return {
        id: license.id,
        name: license.name,
        price,
        quantity: qty,
        lineTotal: roundToTwo(qty * price)
      };
    });

    const licenceCost = roundToTwo(licenceBreakdown.reduce((sum, l) => sum + l.lineTotal, 0));
    const totalLicenceQuantity = licenceBreakdown.reduce((sum, l) => sum + l.quantity, 0);

    const itSupportPrice = getItSupportPrice('IT SUPPORT (PER STATION)');
    const basePerStationPrice = getItSupportPrice('PER STATION + MICROSOFT LICENCE BASIC');
    const standardLicencePrice = getLicencePrice('MICROSOFT BUSINESS STANDARD');
    const premiumLicencePrice = getLicencePrice('MICROSOFT BUSINESS PREMIUM');
    const itServicePrice = getItSupportPrice('IT SERVICE');

    const stationPackages = {
      it_support: { label: 'IT Support only', price: itSupportPrice },
      basic: { label: '+ Microsoft Business Basic', price: basePerStationPrice },
      standard: { label: '+ Microsoft Business Standard', price: roundToTwo(basePerStationPrice + standardLicencePrice) },
      premium: { label: '+ Microsoft Business Premium', price: roundToTwo(basePerStationPrice + premiumLicencePrice) },
    };

    const selectedKeys = itServicesData.selectedPackages || [];
    const perStationPrice = roundToTwo(
      selectedKeys.reduce((sum, key) => sum + (stationPackages[key]?.price || 0), 0)
    );
    const stationCost = roundToTwo(stations * perStationPrice);
    const itServiceCost = roundToTwo(itServicePrice);
    const total = roundToTwo(licenceCost + stationCost + itServiceCost);

    return {
      licenceBreakdown,
      licenceCost,
      totalLicenceQuantity,
      stationPackages,
      perStationPrice,
      stationCost,
      itServicePrice,
      itServiceCost,
      total,
    };
  }, [itServicesData, licenses, itSupportPricing]);

  // These go inside your component
  const handleFocus = (key, valueSetter) => (e) => {
    if (e.target.value === '0') {
      valueSetter(key, '');
    }
  };

  const handleBlur = (key, valueSetter) => (e) => {
    if (e.target.value === '') {
      valueSetter(key, '0');
    }
  };

  const [isSaving, setIsSaving] = useState(false);

  // Update this when receiving data from CallCostsComponent
  const handleServiceChargesData = (data) => {
    setServiceChargesData(data);
   
  };

 



// Add this callback function to handle lease data updates
const handleLeaseDataUpdate = (leaseData) => {
  
  
  setLeaseCalculatorData(leaseData);
};
console.log("digitalServicesDatass", digitalServicesData);
const handleSaveSystemConfig = async () => {
  setIsSaving(true);
  setSaveStatus('saving');
  

  try {
    const systemConfigData = {
      connectionId: selectedConnectionId,
      lineRequirements,
      currentLines,
      dataBroadband,
      hardwareItems: hardwareItems.map(item => ({
        ...item,
        type: 'standard',
      })),
      additionalHardware: additionalHardware.map(item => ({
        ...item,
        type: 'additional',
      })),
      serviceCharges: serviceChargesData,
      itServices: itServicesData,
      itServicesTotal: calculateItServicesCost.total,
      totalMonthlyCost: calculateAllCosts.totalMonthly,
      leasedLines: dataBroadband.leasedLines,
      totalEquipmentCost: calculateTotalHardwareCosts.totalCost,
      leaseCalculatorData: {
        ...leaseCalculatorData,
        paymentProfile: leaseCalculatorData.paymentProfile.toString(),
        networkPayment: leaseCalculatorData.networkPayment.toString(),
        networkSettlementContribution: Number(
          leaseCalculatorData.networkSettlementContribution
        ),
        digital_services: {
          webHostingCost: digitalServicesData.webHostingCost ?? 0,
          totalNewDigitalCost: digitalServicesData.totalNewDigitalCost ?? 0,
          totalFibreDigitalRevenue: digitalServicesData.totalFibreDigitalRevenue ?? 0,
          axoSignalPackage: digitalServicesData.axoSignalPackage ?? null,
          licenceServices: digitalServicesData.licenceServices ?? {},
        },
      },
      telecom_services: telecomServices.map(service => ({
        description: service.description || '',
        existing_tel_no: service.existing_tel_no || '',
        postcode: service.postcode_of_homeworker || '',
        quantity: service.existing_lines || 0,
        service_type: service.service_type || '',
      })),
      save_to_draft: 1,
      updated_by_admin: true,
    };

    let result;

    // ✅ Update if exists, otherwise create new
    if (existingConfigId) {
      console.log("🔄 Updating existing admin config with ID:", existingConfigId);
      result = await updateSystemConfig(existingConfigId, systemConfigData);
    } else {
      console.log("🆕 Creating new admin config...");
      result = await saveSystemConfig(systemConfigData);
      if (result?.id) {
        setExistingConfigId(result.id);
      }
    }

    await QuoteProgressService.saveStep({
      quoteId: selectedConnectionId,
      stepName: "system_config",
      completed: true,
      actions: {},
    });

    if (result && result.success) {
      setSaveStatus('success');
      setTimeout(() => {
        window.location.href = '/dashboard';
      }, 1500);
    }

    return result;
  } catch (error) {
    console.error("❌ Admin operation failed:", error);
    console.error("❌ Error details:", error.response?.data || error.message);
    throw error;
  } finally {
    setIsSaving(false);
  }
};



  // Show loading state while fetching config
  if (isLoadingConfig) {
    return (
      <div className="w-full max-w-5xl mx-auto bg-white rounded-2xl shadow-2xl overflow-hidden border border-blue-100 p-8">
        <div className="flex items-center justify-center space-x-3">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
          <span className="text-blue-600 font-medium">Loading configuration...</span>
        </div>
      </div>
    );
  }

  // Show error state if config loading failed
  if (configError) {
    return (
      <div className="w-full max-w-5xl mx-auto bg-white rounded-2xl shadow-2xl overflow-hidden border border-red-100 p-8">
        <div className="flex items-center justify-center space-x-3 text-red-600">
          <AlertCircle className="w-8 h-8" />
          <span className="font-medium">{configError}</span>
        </div>
        <div className="mt-4 text-center">
          <button
            onClick={() => window.location.reload()}
            className="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors"
          >
            Retry
          </button>
        </div>
      </div>
    );
  }

    return (
        <div className="w-full max-w-5xl mx-auto bg-white rounded-2xl shadow-2xl overflow-hidden border border-blue-100 ">
      {/* Accordion Header */}
      <div className="bg-gradient-to-r from-blue-800 via-blue-900 to-black text-white rouned-lg p-6 cursor-pointer  flex justify-between items-center hover:from-gray-700 hover:via-gray-800 hover:to-gray-900 transition-all duration-300"

         onClick={() => setIsLineServicesOpen(!isLineServicesOpen)}
      >
        <div className="flex items-center space-x-3">
          <Settings className="w-6 h-6" />
          <h2 className="text-xl font-bold tracking-wide">LINE SERVICES</h2>
        </div>
        <div className="flex items-center space-x-2">
          <span className="text-blue-200 text-sm font-medium">
            {isLineServicesOpen ? 'Collapse' : 'Expand'}
          </span>
          <div className="bg-blue-500 rounded-full p-1">
            {isLineServicesOpen ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
          </div>
        </div>
      </div>
        
      {/* Accordion Content */}
      {isLineServicesOpen && (
        
        <div className="bg-gradient-to-br from-blue-50 to-indigo-50">
          {/* LINE REQUIREMENTS Section */}
          <div className="bg-gradient-to-r from-blue-500 to-blue-600 text-white p-4 shadow-md">
            <div className="flex items-center justify-center space-x-2">
              <Wifi className="w-5 h-5" />
              <h3 className="font-bold text-lg">LINE REQUIREMENTS</h3>
            </div>
          </div>
          <TelecomServicesSection
  services={telecomServices}
  onServiceChange={handleServiceChange}
  onAddService={handleAddService}
  onRemoveService={handleRemoveService}
/>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 p-6">
            {/* Left Column - Line Requirements */}
            <div className="bg-white rounded-xl shadow-lg border border-blue-100 overflow-hidden">
              <div className="bg-gradient-to-r from-blue-100 to-blue-200 p-4 border-b border-blue-200">
                <h4 className="font-semibold text-blue-800 text-center">Configuration Requirements</h4>
              </div>
              
              <div className="space-y-1">
                <div className="p-4 hover:bg-blue-50 transition-colors duration-200 flex justify-between items-center border-b border-blue-100">
                  <span className="text-gray-700 font-medium">Existing Isdn2 Channels</span>
                 <input
                      type="number"
                      value={lineRequirements.existingIsdn2Channels}
                      onChange={(e) =>
                        handleLineRequirementChange('existingIsdn2Channels', e.target.value)
                      }
                      onFocus={handleFocus('existingIsdn2Channels', handleLineRequirementChange)}
                      onBlur={handleBlur('existingIsdn2Channels', handleLineRequirementChange)}
                      className="w-20 px-3 py-2 border-2 border-blue-200 rounded-lg text-center font-semibold text-blue-700 focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition-all duration-200"
                      min="0"
                    />


                </div>
                
                <div className="p-4 hover:bg-blue-50 transition-colors duration-200 flex justify-between items-center border-b border-blue-100">
                  <span className="text-gray-700 font-medium">New / Conversion Isdn2 Channel</span>
                  <input
                    type="number"
                    value={lineRequirements.newConversionIsdn2Channel}
                    onChange={(e) => handleLineRequirementChange('newConversionIsdn2Channel', e.target.value)}
                    onFocus={handleFocus('newConversionIsdn2Channel', handleLineRequirementChange)}
                    onBlur={handleBlur('newConversionIsdn2Channel', handleLineRequirementChange)}
                    className="w-20 px-3 py-2 border-2 border-blue-200 rounded-lg text-center font-semibold text-blue-700 focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition-all duration-200"
                    min="0"
                  />
                </div>
                
                <div className="p-4 hover:bg-blue-50 transition-colors duration-200 flex justify-between items-center border-b border-blue-100">
                  <span className="text-gray-700 font-medium">Existing Isdn30 Channels</span>
                  <input
                    type="number"
                    value={lineRequirements.existingIsdn30Channels}
                    onChange={(e) => handleLineRequirementChange('existingIsdn30Channels', e.target.value)}
                    onFocus={handleFocus('existingIsdn30Channels', handleLineRequirementChange)}
                    onBlur={handleBlur('existingIsdn30Channels', handleLineRequirementChange)}
                    className="w-20 px-3 py-2 border-2 border-blue-200 rounded-lg text-center font-semibold text-blue-700 focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition-all duration-200"
                    min="0"
                  />
                </div>
                
                <div className="p-4 hover:bg-blue-50 transition-colors duration-200 flex justify-between items-center">
                  <span className="text-gray-700 font-medium">New Isdn30 Channel</span>
                  <input
                    type="number"
                    value={lineRequirements.newIsdn30Channel}
                    onChange={(e) => handleLineRequirementChange('newIsdn30Channel', e.target.value)}
                    onFocus={handleFocus('newIsdn30Channel', handleLineRequirementChange)}
                    onBlur={handleBlur('newIsdn30Channel', handleLineRequirementChange)}
                    className="w-20 px-3 py-2 border-2 border-blue-200 rounded-lg text-center font-semibold text-blue-700 focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition-all duration-200"
                    min="0"
                  />
                </div>
              </div>
            </div>

            {/* Right Column - Current Lines */}
            <div className="bg-white rounded-xl shadow-lg border border-blue-100 overflow-hidden">
              <div className="bg-gradient-to-r from-blue-100 to-blue-200 p-4 border-b border-blue-200">
                <h4 className="font-semibold text-blue-800 text-center">Current Lines & Line Types</h4>
              </div>
              
              <div className="space-y-1">
                <div className="p-4 hover:bg-blue-50 transition-colors duration-200 flex justify-between items-center border-b border-blue-100">
                  <span className="text-gray-700 font-medium">Hosted Lifetime Licenses with SIP Trunk</span>
                  <input
                    type="number"
                    value={currentLines.hostedLifetimeLicenses}
                    onChange={(e) => handleCurrentLinesChange('hostedLifetimeLicenses', e.target.value)}
                    onFocus={handleFocus('hostedLifetimeLicenses', handleCurrentLinesChange)}
                    onBlur={handleBlur('hostedLifetimeLicenses', handleCurrentLinesChange)}
                    className="w-20 px-3 py-2 border-2 border-blue-200 rounded-lg text-center font-semibold text-blue-700 focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition-all duration-200"
                    min="0"
                  />
                </div>
                
                <div className="p-4 hover:bg-blue-50 transition-colors duration-200 flex justify-between items-center border-b border-blue-100">
                  <span className="text-gray-700 font-medium">Analogue PSTN Lines</span>
                  <input
                    type="number"
                    value={currentLines.analoguePstnLines}
                    onChange={(e) => handleCurrentLinesChange('analoguePstnLines', e.target.value)}
                    onFocus={handleFocus('analoguePstnLines', handleCurrentLinesChange)}
                    onBlur={handleBlur('analoguePstnLines', handleCurrentLinesChange)}
                    className="w-20 px-3 py-2 border-2 border-blue-200 rounded-lg text-center font-semibold text-blue-700 focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition-all duration-200"
                    min="0"
                  />
                </div>
                
                <div className="p-4 hover:bg-blue-50 transition-colors duration-200 flex justify-between items-center border-b border-blue-100">
                  <span className="text-gray-700 font-medium">ADSL / FTTC Broadband</span>
                  <input
                    type="number"
                    value={currentLines.adslFttcBroadband}
                    onChange={(e) => handleCurrentLinesChange('adslFttcBroadband', e.target.value)}
                    onFocus={handleFocus('adslFttcBroadband', handleCurrentLinesChange)}
                    onBlur={handleBlur('adslFttcBroadband', handleCurrentLinesChange)}
                    className="w-20 px-3 py-2 border-2 border-blue-200 rounded-lg text-center font-semibold text-blue-700 focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition-all duration-200"
                    min="0"
                  />
                </div>
                
                <div className="p-4 hover:bg-blue-50 transition-colors duration-200 flex justify-between items-center border-b border-blue-100">
                  <span className="text-gray-700 font-medium">New 4G / 5G Broadband</span>
                  <input
                    type="number"
                    value={currentLines.new4g5gBroadband}
                    onChange={(e) => handleCurrentLinesChange('new4g5gBroadband', e.target.value)}
                    onFocus={handleFocus('new4g5gBroadband', handleCurrentLinesChange)}
                    onBlur={handleBlur('new4g5gBroadband', handleCurrentLinesChange)}
                    className="w-20 px-3 py-2 border-2 border-blue-200 rounded-lg text-center font-semibold text-blue-700 focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition-all duration-200"
                    min="0"
                  />
                </div>
                
                <div className="p-4 hover:bg-blue-50 transition-colors duration-200 flex justify-between items-center">
                  <span className="text-gray-700 font-medium">FTTP / SoGEA Broadband</span>
                  <input
                    type="number"
                    value={currentLines.fttpSogeaBroadband}
                    onChange={(e) => handleCurrentLinesChange('fttpSogeaBroadband', e.target.value)}
                    onFocus={handleFocus('fttpSogeaBroadband', handleCurrentLinesChange)}
                    onBlur={handleBlur('fttpSogeaBroadband', handleCurrentLinesChange)}
                    className="w-20 px-3 py-2 border-2 border-blue-200 rounded-lg text-center font-semibold text-blue-700 focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition-all duration-200"
                    min="0"
                  />
                </div>
              </div>
            </div>
          </div>

          {/* Data Broadband Requirements Section */}
          <div className="bg-gradient-to-r from-blue-500 to-blue-600 text-white p-4 shadow-md">
            <div className="flex items-center justify-center space-x-2">
              <Globe className="w-5 h-5" />
              <h3 className="font-bold text-lg">DATA BROADBAND REQUIREMENTS</h3>
            </div>
          </div>
          
          <div className="p-6">
            <div className="bg-white rounded-xl shadow-lg border border-blue-100 overflow-hidden max-w-2xl mx-auto">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-0">
                <div className="p-6 border-r border-blue-100 hover:bg-blue-50 transition-colors duration-200 flex justify-between items-center">
                  <span className="text-gray-700 font-medium">Starlink Broadband</span>
                  <input
                    type="number"
                    value={dataBroadband.starlinkBroadband}
                    onChange={(e) => handleDataBroadbandChange('starlinkBroadband', e.target.value)}
                    onFocus={handleFocus('starlinkBroadband', handleDataBroadbandChange)}
                    onBlur={handleBlur('starlinkBroadband', handleDataBroadbandChange)}
                    className="w-20 px-3 py-2 border-2 border-blue-200 rounded-lg text-center font-semibold text-blue-700 focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition-all duration-200"
                    min="0"
                  />
                </div>
                
                <div className="p-6 hover:bg-blue-50 transition-colors duration-200 flex justify-between items-center">
                  <span className="text-gray-700 font-medium">Leased Lines</span>
                  <input
                    type="number"
                    value={dataBroadband.leasedLines}
                    onChange={(e) => handleDataBroadbandChange('leasedLines', e.target.value)}
                    onFocus={handleFocus('leasedLines', handleDataBroadbandChange)}
                    onBlur={handleBlur('leasedLines', handleDataBroadbandChange)}
                    className="w-20 px-3 py-2 border-2 border-blue-200 rounded-lg text-center font-semibold text-blue-700 focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition-all duration-200"
                    min="0"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      <div className="bg-gradient-to-r from-blue-800 via-blue-900 to-black text-white my-[20px] rounded-lg p-6 cursor-pointer flex justify-between items-center hover:from-gray-700 hover:via-gray-800 hover:to-gray-900 transition-all duration-300"

        onClick={() => setIsHardwareOpen(!isHardwareOpen)}
      >
        <div className="flex items-center space-x-3">
          <Monitor className="w-6 h-6" />
          <h2 className="text-xl font-bold tracking-wide">HARDWARE</h2>
          <span className="bg-blue-500 text-white px-3 py-1 rounded-full text-sm font-medium">
            {hardwareItems.length} items
          </span>
        </div>
        <div className="flex items-center space-x-2">
          <span className="text-blue-200 text-sm font-medium">
            {isHardwareOpen ? 'Collapse' : 'Expand'}
          </span>
          <div className="bg-blue-500 rounded-full p-1">
            {isHardwareOpen ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
          </div>
        </div>
      </div>

      {/* Accordion Content */}
      {isHardwareOpen && (
        <div className="bg-gradient-to-br from-blue-50 to-indigo-50">
          {/* Add Hardware Button */}
          {/* <div className="p-6 border-b border-blue-200">
            <button
              onClick={() => setShowAddForm(!showAddForm)}
              className="bg-gradient-to-r from-blue-500 to-blue-600 text-white px-6 py-3 rounded-lg font-semibold flex items-center space-x-2 hover:from-blue-600 hover:to-blue-700 transition-all duration-200 shadow-lg hover:shadow-xl transform hover:scale-105"
            >
              <Plus className="w-5 h-5" />
              <span>Add New Hardware</span>
            </button>
          </div>*/}

          {/* Add Hardware Form */}
         {/*  {showAddForm && (
            <div className="p-6 bg-white mx-6 rounded-xl shadow-lg border border-blue-200 mb-6">
              <h3 className="text-lg font-bold text-blue-800 mb-4 flex items-center space-x-2">
                <Plus className="w-5 h-5" />
                <span>Add New Hardware Item</span>
              </h3>
              <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Hardware Name</label>
                  <input
                    type="text"
                    value={newItem.name}
                    onChange={(e) => setNewItem({...newItem, name: e.target.value})}
                    className="w-full px-3 py-2 border-2 border-blue-200 rounded-lg focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition-all duration-200"
                    placeholder="Enter hardware name"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Category</label>
                  <select
                    value={newItem.category}
                    onChange={(e) => setNewItem({...newItem, category: e.target.value})}
                    className="w-full px-3 py-2 border-2 border-blue-200 rounded-lg focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition-all duration-200"
                  >
                    {categories.map(cat => (
                      <option key={cat.name} value={cat.name}>{cat.icon} {cat.name}</option>
                    ))}
                  </select>
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Quantity</label>
                  <input
                    type="number"
                    value={newItem.quantity}
                    onChange={(e) => setNewItem({...newItem, quantity: parseInt(e.target.value) || 0})}
                    className="w-full px-3 py-2 border-2 border-blue-200 rounded-lg focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition-all duration-200"
                    min="0"
                  />
                </div>
                <div className="flex items-end space-x-2">
                  <button
                    onClick={handleAddItem}
                    className="bg-green-500 text-white px-4 py-2 rounded-lg font-semibold hover:bg-green-600 transition-colors duration-200 flex items-center space-x-1"
                  >
                    <Plus className="w-4 h-4" />
                    <span>Add</span>
                  </button>
                  <button
                    onClick={() => setShowAddForm(false)}
                    className="bg-gray-500 text-white px-4 py-2 rounded-lg font-semibold hover:bg-gray-600 transition-colors duration-200"
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          )} */}

          {/* Hardware Items by Category */}
          <div className="p-6 space-y-6">
            {Object.entries(groupedItems).map(([category, items]) => (
              <div key={category} className="bg-white rounded-xl shadow-lg border border-blue-100 overflow-hidden">
                <div className="bg-gradient-to-r from-blue-100 to-blue-200 p-4 border-b border-blue-200">
                  <div className="flex items-center space-x-2">
                    {getIconComponent(category)}
                    <h4 className="font-bold text-blue-800">{category}</h4>
                    <span className="bg-blue-500 text-white px-2 py-1 rounded-full text-xs font-medium">
                      {items.length}
                    </span>
                  </div>
                </div>
                
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 p-4">
                  {items.map(item => (
                    <div key={item.id} className="bg-gradient-to-br from-blue-50 to-blue-100 rounded-lg p-4 border border-blue-200 hover:shadow-md transition-all duration-200">
                      <div className="flex justify-between items-start mb-3">
                        <div className="flex items-center space-x-3">
                           {(item.icon && typeof item.icon === 'string' && item.icon.startsWith('/images')) ? (
                              <img 
                                src={item.icon} 
                                alt={item.name}
                                className="w-13 h-12 object-contain rounded-md"
                                onError={(e) => {
                                  e.target.onerror = null; 
                                  e.target.src = '/images/placeholder.jpg';
                                  e.target.className = 'w-12 h-12 object-contain rounded-md bg-gray-100';
                                }}
                              />
                            ) : (
                              <span className="text-2xl">{(item.icon && typeof item.icon === 'string') ? item.icon : '⚙️'}</span>
                            )}
                          <div>
                            {editingId === item.id ? (
                              <input
                                type="text"
                                value={item.name}
                                onChange={(e) => handleEditItem(item.id, 'name', e.target.value)}
                                className="font-semibold text-gray-800 bg-white border border-blue-300 rounded px-2 py-1 text-sm"
                                onBlur={() => setEditingId(null)}
                                onKeyPress={(e) => e.key === 'Enter' && setEditingId(null)}
                                autoFocus
                              />
                            ) : (
                              <h5 
                                className="font-semibold text-gray-800 cursor-pointer hover:text-blue-600"
                               
                              >
                                {item.name}
                              </h5>
                            )}
                            <p className="text-xs text-gray-600">{item.category}</p>
                          </div>
                        </div>
                         {/* <button
                          onClick={() => handleDeleteItem(item.id)}
                          className="text-red-500 hover:text-red-700 hover:bg-red-100 p-1 rounded transition-colors duration-200"
                        >
                          <X className="w-4 h-4" />
                        </button> */}
                      </div>
                      
                     <div className="flex flex-col space-y-2">
                        <div className="flex items-center justify-between">
                          <span className="text-sm font-medium text-gray-600">Quantity:</span>
                          <input
                            type="number"
                            value={item.quantity}
                            onChange={(e) => {
                              if (item.name === 'Mobile App' && autoCalculateMobileApp) return;
                              handleEditItem(item.id, 'quantity', e.target.value);
                            }}
                            onFocus={handleHardwareFocus(item.id, 'quantity')}
                            onBlur={handleHardwareBlur(item.id, 'quantity')}
                            className={`w-20 px-2 py-1 border-2 rounded-lg text-center font-semibold transition-all duration-200
                              ${item.name === 'Mobile App' && autoCalculateMobileApp 
                                ? 'bg-gray-100 text-gray-500 border-gray-300 cursor-not-allowed' 
                                : 'bg-white text-blue-700 border-blue-200 focus:border-blue-500 focus:ring-1 focus:ring-blue-200'}
                            `}
                            min="0"
                            disabled={item.name === 'Mobile App' && autoCalculateMobileApp}
                          />
                        </div>

                        {item.name === 'Mobile App' && (
                          <label className="inline-flex items-center space-x-2 text-sm mt-1">
                            <input
                              type="checkbox"
                              checked={autoCalculateMobileApp}
                              onChange={() => setAutoCalculateMobileApp(!autoCalculateMobileApp)}
                              className="form-checkbox h-4 w-4 text-blue-600 transition duration-150"
                            />
                            <span className="text-gray-700">Auto-calculate</span>
                          </label>
                        )}
                      </div>

                    </div>
                  ))}
                </div>
              </div>
            ))}
            
          </div>
          <div className="p-6 space-y-6">
            {Object.entries(
              additionalHardware.reduce((acc, item) => {
                acc[item.category] = acc[item.category] || [];
                acc[item.category].push(item);
                return acc;
              }, {})
            ).map(([category, items]) => (
              <div key={category} className="bg-white rounded-xl shadow-lg border border-blue-100 overflow-hidden">
                <div className="bg-gradient-to-r from-blue-100 to-blue-200 p-4 border-b border-blue-200">
                  <div className="flex items-center space-x-2">
                    {getIconComponent(category)}
                    <h4 className="font-bold text-blue-800">{category}</h4>
                    <span className="bg-blue-500 text-white px-2 py-1 rounded-full text-xs font-medium">
                      {items.length}
                    </span>
                  </div>
                </div>

              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 p-4">
                {items.map((item) => {
                  const isEmail = item.category === 'E-mail';
                  const otherTotal = 90; // Replace this with a dynamic sum if needed
                  const computedQuantity = isEmail
                    ? (parseInt(emailExtraInput) || 0) + otherTotal
                    : item.quantity;

                  return (
                    <div
                      key={item.id || item.name}
                      className="bg-white border border-blue-200 rounded-xl p-4 shadow-sm transition hover:shadow-md space-y-4"
                    >
                      {/* Item Header */}
                      <div className="flex justify-between items-center">
                        
                        <div>
                          {/* FIXED: Added flex layout and proper icon handling */}
                          <div className="flex items-center space-x-3 mb-2">
                            {(item.icon && typeof item.icon === 'string' && item.icon.startsWith('/images')) ? (
                              <img 
                                src={item.icon} 
                                alt={item.name || item.description || 'Hardware item'}
                                className="w-12 h-12 object-contain rounded-md"
                                onError={(e) => {
                                  e.target.onerror = null; 
                                  e.target.src = '/images/placeholder.jpg';
                                  e.target.className = 'w-12 h-12 object-contain rounded-md bg-gray-100';
                                }}
                              />
                            ) : (
                              <span className="text-2xl">{(item.icon && typeof item.icon === 'string') ? item.icon : '⚙️'}</span>
                            )}
                            <div>
                              <h5 className="font-semibold text-blue-800">{item.name}</h5>
                              <p className="text-xs text-gray-500">{item.category}</p>
                            </div>
                          </div>
                        </div>
                         {/* <button
                          onClick={() => handleDeleteItem(item.id)}
                          className="text-red-500 hover:text-red-600 hover:bg-red-100 p-1 rounded transition"
                        >
                          <X className="w-4 h-4" />
                        </button>*/}
                      </div>

                      <div className="flex justify-between items-center">
                        <label className="text-sm text-gray-700 font-medium">Quantity</label>
                        <input
                          type="number"
                          value={item.quantity}
                          onChange={(e) => handleEditItem(item.id, 'quantity', parseInt(e.target.value))}
                          onFocus={handleAdditionalHardwareFocus(item.id, 'quantity')}
                          onBlur={handleAdditionalHardwareBlur(item.id, 'quantity')}
                          className="w-20 px-2 py-1 border border-blue-300 rounded-lg text-right font-semibold text-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-200"
                          min="0"
                        />
                      </div>
                    </div>
                  );
                })}
              </div>
              </div>
            ))}
          </div>
            
        </div>
      )}
        {/* ── IT SERVICES / MICROSOFT LICENCE RESALE ── */}
      <div
        className="bg-gradient-to-r from-blue-800 via-blue-900 to-black text-white my-[20px] rounded-lg p-6 cursor-pointer flex justify-between items-center hover:from-gray-700 hover:via-gray-800 hover:to-gray-900 transition-all duration-300"
        onClick={() => setIsItServicesOpen(!isItServicesOpen)}
      >
        <div className="flex items-center space-x-3">
          <Globe className="w-6 h-6" />
          <h2 className="text-xl font-bold tracking-wide">IT SERVICES & MICROSOFT LICENCES</h2>
          {calculateItServicesCost.total > 0 && (
            <span className="bg-blue-500 text-white px-3 py-1 rounded-full text-sm font-medium">
              £{calculateItServicesCost.total.toFixed(2)}/mo
            </span>
          )}
        </div>
        <div className="flex items-center space-x-2">
          <span className="text-blue-200 text-sm font-medium">
            {isItServicesOpen ? 'Collapse' : 'Expand'}
          </span>
          <div className="bg-blue-500 rounded-full p-1">
            {isItServicesOpen ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
          </div>
        </div>
      </div>

      {isItServicesOpen && (
        <div className="bg-gradient-to-br from-blue-50 to-indigo-50 p-6 space-y-6">

          {/* Microsoft licences */}
          <div className="bg-white rounded-xl shadow-lg border border-blue-100 overflow-hidden max-w-3xl mx-auto">
            <div className="bg-gradient-to-r from-blue-100 to-blue-200 p-4 border-b border-blue-200">
              <h4 className="font-semibold text-blue-800 text-center">Microsoft 365 Licences</h4>
            </div>
            {licenses.length === 0 ? (
              <div className="p-4 text-sm text-gray-500 text-center">
                No licence pricing found — add licences in the Mechanics Calculator first.
              </div>
            ) : (
              <div className="divide-y divide-blue-100">
                {licenses.map(license => {
                  const qty = itServicesData.licenceQuantities[license.id] ?? 0;
                  const lineTotal = calculateItServicesCost.licenceBreakdown.find(l => l.id === license.id)?.lineTotal || 0;
                  return (
                    <div key={license.id} className="p-4 hover:bg-blue-50 transition-colors duration-200">
                      <div className="flex justify-between items-center">
                        <div>
                          <span className="text-gray-700 font-medium">{license.name}</span>
                          <span className="ml-2 text-xs text-gray-500">
                            £{parseFloat(license.price).toFixed(2)} / licence / month
                          </span>
                        </div>
                        <div className="flex items-center space-x-3">
                          <input
                            type="number"
                            value={qty}
                            onChange={(e) => handleLicenceQuantityChange(license.id, e.target.value)}
                            onFocus={handleFocus(license.id, () => {})}
                            className="w-20 px-3 py-2 border-2 border-blue-200 rounded-lg text-center font-semibold text-blue-700 focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition-all duration-200"
                            min="0"
                            placeholder="0"
                          />
                          <span className="w-20 text-right text-sm font-semibold text-gray-700">
                            £{lineTotal.toFixed(2)}
                          </span>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            )}
          </div>

          {/* Stations & Package */}
          <div className="bg-white rounded-xl shadow-lg border border-blue-100 overflow-hidden max-w-3xl mx-auto">
            <div className="bg-gradient-to-r from-blue-100 to-blue-200 p-4 border-b border-blue-200">
              <h4 className="font-semibold text-blue-800 text-center">Stations & IT Service</h4>
            </div>
            <div className="p-4 space-y-4">
              <div className="flex justify-between items-center">
                <span className="text-gray-700 font-medium">Number of Stations</span>
                <input
                  type="number"
                  value={itServicesData.numberOfStations}
                  onChange={(e) => handleStationsChange(e.target.value)}
                  onFocus={handleFocus('numberOfStations', (field, val) => handleStationsChange(val))}
                  onBlur={handleBlur('numberOfStations', (field, val) => handleStationsChange(val))}
                  className="w-20 px-3 py-2 border-2 border-blue-200 rounded-lg text-center font-semibold text-blue-700 focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition-all duration-200"
                  min="0"
                />
              </div>

              <div className="pt-3 border-t border-blue-100">
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Station Package (per station — select any combination)
                </label>
                <div className="space-y-2">
                  {Object.entries(calculateItServicesCost.stationPackages).map(([key, pkg]) => (
                    <label
                      key={key}
                      className="flex items-center justify-between p-2 rounded-lg border border-blue-100 hover:bg-blue-50 cursor-pointer"
                    >
                      <span className="flex items-center space-x-2">
                        <input
                          type="checkbox"
                          checked={(itServicesData.selectedPackages || []).includes(key)}
                          onChange={(e) => handleTogglePackage(key, e.target.checked)}
                          className="w-4 h-4 rounded accent-blue-500 cursor-pointer"
                        />
                        <span className="text-sm text-gray-700">{pkg.label}</span>
                      </span>
                      <span className="text-sm font-semibold text-blue-700">
                        £{pkg.price.toFixed(2)} / station
                      </span>
                    </label>
                  ))}
                </div>
              </div>

              <div className="flex justify-between items-center pt-3 border-t border-blue-100">
                <span className="text-sm font-medium text-gray-700">
                  Total ({parseInt(itServicesData.numberOfStations) || 0} stations × £{calculateItServicesCost.perStationPrice.toFixed(2)})
                </span>
                <span className="text-sm font-bold text-blue-700">
                  £{calculateItServicesCost.stationCost.toFixed(2)}
                </span>
              </div>
            </div>
          </div>

          {/* Summary */}
          <div className="max-w-3xl mx-auto bg-gradient-to-r from-blue-50 to-purple-50 rounded-xl border border-blue-200 p-4 space-y-2">
            <div className="flex justify-between text-sm text-gray-600">
              <span>Microsoft licences ({calculateItServicesCost.totalLicenceQuantity} total)</span>
              <span>£{calculateItServicesCost.licenceCost.toFixed(2)}</span>
            </div>
            <div className="flex justify-between text-sm text-gray-600">
              <span>Station packages ({parseInt(itServicesData.numberOfStations) || 0} stations × £{calculateItServicesCost.perStationPrice.toFixed(2)})</span>
              <span>£{calculateItServicesCost.stationCost.toFixed(2)}</span>
            </div>
            <div className="flex justify-between text-sm text-gray-600">
              <span>IT service charge</span>
              <span>£{calculateItServicesCost.itServiceCost.toFixed(2)}</span>
            </div>
            <div className="flex justify-between items-center pt-2 border-t border-blue-200">
              <span className="text-sm font-semibold text-gray-800">Total</span>
              <span className="text-lg font-bold text-green-600">
                £{calculateItServicesCost.total.toFixed(2)} / month
              </span>
            </div>
          </div>
        </div>
      )}
     <CallCostsComponent isHostedLifetimeLicenses={currentLines.hostedLifetimeLicenses} selectedConnectionId={selectedConnectionId} totalMonthlyCost={calculateAllCosts.totalMonthly} leasedLines={dataBroadband.leasedLines} totalEquipmentCost={calculateTotalHardwareCosts.totalCost} onServiceChargesUpdate={handleServiceChargesData} onLeaseDataUpdate={handleLeaseDataUpdate} serviceChargesData ={serviceChargesData}
  leaseCalculatorData={leaseCalculatorData}  hardwareItems={hardwareItems}
  additionalHardware={additionalHardware}
  currentLines={currentLines}
  dataBroadband={dataBroadband}
  lineRequirements={lineRequirements}
  telecomServices={telecomServices}
  adminUpdate={adminUpdate}/>
      <div className="flex justify-end mt-6">
  <button
    type="button"
    onClick={handleSaveSystemConfig}
    disabled={isSaving}
    className={`
      px-6 py-3 rounded-lg font-semibold flex items-center space-x-2 transition-all duration-200
      ${isSaving 
        ? 'bg-gray-400 cursor-not-allowed' 
        : 'bg-gradient-to-r from-blue-600 to-purple-600 hover:from-blue-700 hover:to-purple-700'
      }
      ${saveStatus === 'success' ? 'bg-green-600' : ''}
      ${saveStatus === 'error' ? 'bg-red-600' : ''}
    `}
  >
    {isSaving ? (
      <>
        <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white"></div>
        <span>Saving Configuration...</span>
      </>
    ) : saveStatus === 'success' ? (
      <>
        <CheckCircle className="w-5 h-5" />
        <span>Saved! Redirecting...</span>
      </>
    ) : saveStatus === 'error' ? (
      <>
        <AlertCircle className="w-5 h-5" />
        <span>Save Failed</span>
      </>
    ) : (
      <>
        <CheckCircle className="w-5 h-5" />
        <span>Update Configuration</span>
      </>
    )}
  </button>
</div>
        
    </div>
    );
  

 
};

export default AdminSystemConfig;